// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__33Xsv","overflowing":"ReadFullNote_overflowing__3jbII"};